import { IEpgItem } from "../../interfaces/IEpgItem.ts";
import DateHelper from "../../helpers/dateHelper.ts";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { usePlayerPage } from "../../hooks/usePlayerPage.tsx";
import { useAppSelector } from "../../stores/store.ts";

interface IProps {
    epg: IEpgItem,
    firstElemId: number
}

const PlayerEpgPrevious = ({ epg, firstElemId }: IProps) => {
    const { handleClickPreviousEpgItem } = usePlayerPage();
    const handleOnClick = () => {
        handleClickPreviousEpgItem();
    }
    const lastOperationType = useAppSelector(store => store.playerUI.lastOperationType);
    return (
        <div className={"md:flex"}>
            <button className={"h-full my-auto mr-0 md:mr-4 disabled:text-neutral-600"} onClick={handleOnClick}
                disabled={epg && epg.id === firstElemId}>
                <ChevronLeftIcon className={"w-10 h-10"} />
            </button>
            <div
                className={"hidden lg:flex flex-col h-full w-40 xl:w-64 2xl:w-72 shrink-0 text-xl justify-center text-right overflow-hidden"}>
                <p className={"font-light text-base"}>Poprzednio</p>
                <div className={`${lastOperationType === "CHANGE_EPG_RIGHT" && "playerChannel-scrollRightAnimation"} ${lastOperationType === "CHANGE_EPG_LEFT" && "playerChannel-scrollLeftAnimation"} overflow-hidden`}>
                    <p className={"truncate w-full text-base"}>{epg?.name}</p>
                    <p className={"text-neutral-400 text-sm"}>{`${epg?.start_timestamp ?
                        DateHelper.GetHourAndMinuteFromUnixTimespanDate(epg?.start_timestamp) : ""} - 
                    ${epg?.stop_timestamp ? DateHelper.GetHourAndMinuteFromUnixTimespanDate(epg?.stop_timestamp) : ""}
                    `}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PlayerEpgPrevious;